import http from '@/plugins/axios'; 

export async function get_province(payload) {
    const response = await http.get(`provinces`, {params: payload});
    return response.data;

}